export const hasTransparency = (imageUrl, callback) => {
  const img = new Image();
  img.crossOrigin = "Anonymous"; // Ensure CORS is enabled

  img.onload = function () {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);

    const imageData = ctx.getImageData(0, 0, img.width, img.height);
    const pixels = imageData.data;

    let hasTransparency = false;

    for (let i = 3; i < pixels.length; i += 4) {
      if (pixels[i] < 255) {
        hasTransparency = true;
        break;
      }
    }

    callback(hasTransparency);
  };

  img.onerror = function () {
    console.error("Error loading image.");
    callback(false);
  };

  img.src = imageUrl;
};
